import Vue from 'vue';

Vue.config.devtools = false
Vue.config.productionTip = false

import TaDropdown from './components/TaDropdown.vue';
import BrandDropdown from './components/BrandDropdown.vue';
import PublisherDropdown from './components/PublisherDropdown.vue';
import ManagementPublisherDropdown from './components/ManagementPublisherDropdown.vue';
import PublicationDropdown from './components/PublicationDropdown.vue';
import EditionDropdown from './components/EditionDropdown.vue';
import ContactDropdown from './components/ContactDropdown.vue';
import CampaignDropdown from './components/CampaignDropdown.vue';
import TypeDropdown from './components/TypeDropdown.vue';
import FormatDropdown from './components/FormatDropdown.vue';
import CountryDropdown from './components/CountryDropdown.vue';
import AddModal from './components/AddModal.vue';
import DeleteModal from './components/DeleteModal.vue';
import DuplicateModal from './components/DuplicateModal.vue';
import RetryModal from './components/RetryModal.vue';
import SubmitModal from './components/SubmitModal.vue';
import UtmInput from './components/UtmInput.vue';
import AdStatusDropdown from './components/AdStatusDropdown.vue';
import AdModifyModal from './components/AdModifyModal.vue';
import AllowedUsers from './components/AllowedUsers.vue';
import CompareAds from './components/CompareAds/Parent.vue';
import Calendar from './components/Calendar/Parent.vue';
import ColumnFilter from './components/ColumnFilter.vue';
import UploadIcon from './components/Files/UploadIcon.vue';
import UploadAhref from './components/Files/UploadAhref.vue';
import UploadButton from './components/Files/UploadButton.vue';
import UploadModal from './components/Files/UploadModal.vue';
import UploadFile from './components/Files/UploadFile.vue';
import SelectButton from './components/Files/SelectButton.vue';
import SelectList from './components/Files/SelectList.vue';
import SelectModal from './components/Files/SelectModal.vue';
import ThumbFile from './components/Files/ThumbFile.vue';
import ThumbOverview from './components/Files/ThumbOverview.vue';
import DistributionClicks from './components/DistributionClicks.vue';
import TagList from './components/Tags/TagList.vue';

import axios from "axios"
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios = axios;

import qs from "qs"
window.qs = qs;

const app = new Vue({
    el: '#app',
    components: {
        TaDropdown,
        BrandDropdown,
        PublisherDropdown,
        ManagementPublisherDropdown,
        PublicationDropdown,
        EditionDropdown,
        ContactDropdown,
        CampaignDropdown,
        TypeDropdown,
        FormatDropdown,
        CountryDropdown,
        AddModal,
        DeleteModal,
        DuplicateModal,
        RetryModal,
        SubmitModal,
        UtmInput,
        AdStatusDropdown,
        AdModifyModal,
        AllowedUsers,
        CompareAds,
        Calendar,
        ColumnFilter,
        UploadIcon,
        UploadAhref,
        UploadButton,
        UploadModal,
        UploadFile,
        SelectButton,
        SelectList,
        SelectModal,
        ThumbFile,
        ThumbOverview,
        DistributionClicks,
        TagList
    },
});
